import { ReactElement, lazy } from 'react'

import { FEATURE_TYPES } from 'featureFlagsConfig'
import { CatalogueMainPage } from 'pages/catalogue/main/CatalogueMainPage'
import { AppPermissions } from 'types/permissions/enums'
import { RoutesManager } from 'utils/routesManager'

interface AppRoute {
  Component: ReactElement
  path: string
  permissions?: AppPermissions | AppPermissions[]
  requireAllPermissions?: boolean
  flag?: FEATURE_TYPES
}

const ApplicationPage = lazy(() =>
  import('pages/applications/view/ApplicationViewPage').then(({ ApplicationViewPage }) => ({
    default: ApplicationViewPage,
  })),
)

export const routes: AppRoute[] = [
  {
    Component: <CatalogueMainPage />,
    path: RoutesManager.main.root.pattern,
  },
  {
    Component: <ApplicationPage />,
    path: RoutesManager.applications.view.pattern,
  },
]
